module.exports = "/novo-activation05f9e76c7be0a3f648f62113448b151a.png";